import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteQuestionRPC } from "./deleteQuestionRPC";

export class DeleteQuestionRPCClientImpl extends DeleteQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteQuestionRPC.Request): Promise<LeoRPCResult<DeleteQuestionRPC.Response, DeleteQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/DeleteQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteQuestionRPC.ResponseDTO,
      DeleteQuestionRPC.Errors.ErrorsDTO,
      DeleteQuestionRPC.Response,
      DeleteQuestionRPC.Errors.Errors
    >(
      response,
      "survey/DeleteQuestion",
      DeleteQuestionRPC.Response.fromDTO,
      DeleteQuestionRPC.Errors.fromDTO
    );
  }
}
